import {css} from 'lit';
export const styles = css`:host {
  --button-size: 28px;
  --button-border: 2px solid var(--button-color);
  --button-border-radius: 4px;
  --button-icon-size: var(--font-size-md);
  --count-label-display: inline;
}

:host([readOnlyOn]) {
  --button-icon-size: 24px;
}

.right {
  display: flex;
  align-items: center;
}

.left {
  margin-right: 16px;
}

.bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 4px;
}

.bottom ef-label {
    margin-top: 4px;
    margin-bottom: 4px;
    margin-right: 8px;
  }

@media (max-width: 767px) {

.bottom {
    margin-top: 2px
}
  }

:host([layout='column']) {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

:host([layout='row']) .left {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
`;
export default styles;
